import { chatEE } from '@/layout/events/chat-event-emitter';
import { Authorize } from '@/shared/components/authorize';
import { PersonAdd } from '@mui/icons-material';
import { Fab, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ConversationType } from '../../models/conversation';

interface ConversationAddMemberFabProps {
  conversationId: string;
  conversationType: ConversationType;
}

export const ConversationAddMemberFab: React.FC<ConversationAddMemberFabProps> = ({
  conversationId,
  conversationType
}) => {
  const { t } = useTranslation();

  if (conversationType !== 'GROUP') return undefined;
  return (
    <Authorize conversationId={conversationId} permissions={['MEMBER_ADD']}>
      <Tooltip title={t('conversations.members.addButton')} placement='left'>
        <Fab
          aria-label={t('conversations.members.addButton')}
          color='primary'
          size='small'
          onClick={(e) => {
            e.preventDefault();
            chatEE.emit('add-member', conversationId);
          }}
        >
          <PersonAdd />
        </Fab>
      </Tooltip>
    </Authorize>
  );
};

export default ConversationAddMemberFab;
